/**
 * External dependencies
 */
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { has } from 'lodash';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper/core';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import { withDispatch } from '@wordpress/data';
import { MediaPlaceholder, RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { compose } from '@wordpress/compose';
import { applyFilters, addFilter } from '@wordpress/hooks';

/**
 * Internal dependencies
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

// install Swiper modules
SwiperCore.use( [ Pagination, Navigation, Autoplay ] );

const Edit = ( props ) => {
	const { isSelected,
		className,
		attributes,
		selectBlock } = props;
	const { images, imagesData, columns, hasPagination, hasNavigation, spaceBetween, blockClientId } = attributes;

	const selectCaption = ( newImage, _images ) => {
		const currentImage = find( _images, ( obj ) => parseInt( obj?.id ) === newImage?.id );
		return Array.isArray( currentImage?.caption ) ? currentImage?.caption?.[ 0 ] : currentImage?.caption || newImage?.caption || '';
	};

	const selectImgLink = ( newImage, _images ) => {
		const currentImage = find( _images, ( obj ) => parseInt( obj?.id ) === newImage?.id );
		return currentImage?.imgLink || newImage?.imgLink || '';
	};

	const pickRelevantMediaFiles = ( image ) => {
		// const { imagesData } = props.attributes;
		// const imageProps = pick( image, [ 'alt', 'id', 'link', 'caption', 'imgLink' ] );
		// imageProps.url = get( image, [ 'sizes', 'large', 'url' ] ) || get( image, [ 'media_details', 'sizes', 'large', 'source_url' ] ) || image.url;
		// const imgKey = findIndex( images, function( img ) {
		// 	return img.url === imageProps.url;
		// } );
		// imageProps.imgLink = imgKey >= 0 ? images[ imgKey ].imgLink : '';
		props.setAttributes( {
			imagesData: {
				...imagesData,
			},
		} );
		return image;
	};
	const onSelectImages = ( newImages ) => {
		// const { images } = props.attributes;
		props.setAttributes( {
			images: newImages.map( ( image ) => ( {
				...pickRelevantMediaFiles( image ),
				caption: selectCaption( image, images ),
				imgLink: selectImgLink( image, images ),
			} ) ),
		} );
	};

	const onUploadError = ( ) => {
		// const { noticeOperations } = props;
		// noticeOperations.removeAllNotices();
		// noticeOperations.createErrorNotice( message );
	};

	const updateImagesData = ( id, key, value ) => {
		// const { imagesData } = props.attributes;
		if ( ! has( imagesData, id ) ) {
			imagesData[ id ] = {};
		}
		imagesData[ id ][ key ] = value;
		props.setAttributes( {
			imagesData: {
				...imagesData,
			},
		} );
	};

	let wrapperClasses = [ className,
		`gutenify-section-${ blockClientId }` ];
	wrapperClasses = classnames( applyFilters( `gutenify--${ hookPrefix }--wrapper-class`, wrapperClasses, props ) );
	const hasImages = !! images.length;
	const title = ! hasImages && __( 'Gallery Carousel' );
	const navFigureClasses = classnames(
		'gutenify--figure', {
		}
	);

	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<BaseWrapper { ...props }>
			{ hasImages && <Swiper
				spaceBetween={ spaceBetween }
				slidesPerView={ columns }
				loop={ true }
				navigation={ hasNavigation }
				pagination={ hasPagination }
				scrollbar={ { draggable: true } }
				onClick={ () => selectBlock( 'slide click' ) }
				autoplay={ false }
				className="gutenify-gallery-carousel"
				allowTouchMove={ false }
			>{ images.map( ( image ) => {
					return (
						<SwiperSlide className="gutenify-gallery-carousel-item" key={ image.id || image.url }>
							<div className="gutenify-slider-image-wrapper">
								<div className="gutenify-slider-content-image">

									<figure className={ navFigureClasses }>
										<img src={ image.url } alt={ image.alt } data-link={ image.link } data-id={ image.id } className={ image.id ? `wp-image-${ image.id }` : null } />
									</figure>
								</div>
							</div>
							<div className="gutenify-slider-content-wrapper">
								<div className="gutenify-slider-content-inner">
									<RichText
										tagName="h2" // The tag here is the element output and editable in the admin
										value={ has( imagesData[ image.id ], 'title' ) ? imagesData[ image.id ].title : '' } // Any existing content, either from the database or an attribute default
										allowedFormats={ [ 'core/bold', 'core/italic', 'core/link' ] } // Allow the content to be made bold or italic, but do not allow other formatting options
										onChange={ ( content ) => {
											updateImagesData( image.id, 'title', content );
										} } // Store updated content as a block attribute
										placeholder={ __( 'Heading...' ) } // Display this text before any content has been added by the user
										className="gutenify-slider-title"
									/>
									<RichText
										tagName="h3" // The tag here is the element output and editable in the admin
										value={ has( imagesData[ image.id ], 'subTitle' ) ? imagesData[ image.id ].title : '' } // Any existing content, either from the database or an attribute default
										allowedFormats={ [ 'core/bold', 'core/italic', 'core/link' ] } // Allow the content to be made bold or italic, but do not allow other formatting options
										onChange={ ( content ) => {
											updateImagesData( image.id, 'subTitle', content );
										} } // Store updated content as a block attribute
										placeholder={ __( 'Sub Heading...' ) } // Display this text before any content has been added by the user
										className="gutenify-slider-sub-title"
									/>
									<div className="gutenify-slider-content-inner-wrapper">
										<div className="gutenify-slider-content clear-fix">
											<RichText
												tagName="p" // The tag here is the element output and editable in the admin
												value={ has( imagesData[ image.id ], 'description' ) ? imagesData[ image.id ].description : '' } // Any existing content, either from the database or an attribute default
												allowedFormats={ [ 'core/bold', 'core/italic', 'core/link' ] } // Allow the content to be made bold or italic, but do not allow other formatting options
												onChange={ ( content ) => {
													updateImagesData( image.id, 'description', content );
												} } // Store updated content as a block attribute
												placeholder={ __( 'Content...' ) } // Display this text before any content has been added by the user
											/>
										</div>
									</div>
								</div>
							</div>
						</SwiperSlide>
					);
				} ) }</Swiper> }
			<div >
				<MediaPlaceholder
					addToGallery={ hasImages }
					isAppender={ hasImages }
					className="gutenify-gallery-figure"
					disableMediaButtons={ hasImages && ! isSelected }
					// icon={ ! hasImages && <Icon icon={ props.icon } /> }
					labels={ {
						title,
						instructions: ! hasImages && __( 'Drag images, upload new ones or select files from your library.', 'coblocks' ),
					} }
					onSelect={ onSelectImages }
					accept="image/*"
					allowedTypes={ [ 'image' ] }
					multiple
					value={ hasImages ? images : undefined }
					onError={ onUploadError }
				/>
			</div>
		</BaseWrapper>
	</div>;
};

export default compose( [
	withDispatch( ( dispatch, ownProps ) => {
		const { selectBlock } = dispatch( 'core/block-editor' );

		return {
			selectBlock: () => {
				selectBlock( ownProps.clientId );
			},
		};
	} ),
] )( Edit );
